import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

import LoanDataTable from '../credit/LoanDataTable'
export default function CredituploadPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CredituploadPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('creditupload')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div><LoanDataTable/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
